// ギネス記録に挑戦中！ クリックでバナーを非表示
function floatBtn(){
    const floatBnr = document.getElementById("js-float-bnr");
    floatBnr.style.display ="none";
}